/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { type ComponentProps } from 'react';
import './Spotify.scss';

/**
 * This is the Spotify component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Spotify(props: ComponentProps<'iframe'>) {
  return (
    <div className="block podcast spotify" appear="true">
      <div>
        <iframe {...props} />
      </div>
    </div>
  );
}

export default Spotify;
